import React from 'react';

export const Dots: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <g transform="translate(-1498.5 -246.5)">
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="translate(1502 257)"
        fill="currentColor"
      />
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="translate(1509 257)"
        fill="currentColor"
      />
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="translate(1516 257)"
        fill="currentColor"
      />
    </g>
  </svg>
);
